var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscuss({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2057_1753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9694 14.7273C10.9102 14.7273 0.333008 23.591 0.333008 34.6705C0.442695 40.3214 3.1242 45.6137 7.61593 49.0444L4.76481 59.0455L18.0602 53.9488C20.0003 54.3817 21.9814 54.6045 23.9693 54.6136C37.0283 54.6136 47.6057 45.7499 47.6057 34.6704C47.6057 23.5908 37.0284 14.7273 23.9694 14.7273ZM23.9694 51.6591C22.1806 51.6538 20.3976 51.4557 18.6512 51.0681C18.4401 51.0453 18.2271 51.0453 18.0159 51.0681C17.6526 51.0662 17.292 51.1314 16.9523 51.2602L9.19662 54.1556L10.4227 49.8567C10.7472 48.7208 10.3638 47.5006 9.44773 46.7545C5.65209 43.8823 3.38204 39.4293 3.28746 34.6705C3.28746 25.3045 12.5647 17.6819 23.9693 17.6819C35.3738 17.6819 44.6511 25.3046 44.6511 34.6705C44.6511 44.0363 35.374 51.6591 23.9694 51.6591Z",
    fill: "#4D2481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3329 19.8978C65.3329 8.8182 54.7557 -0.0454102 41.6965 -0.0454102C31.9465 -0.0454102 23.5851 4.93306 19.9658 12.0535C21.1461 11.891 22.3349 11.7973 23.5261 11.7728C27.0421 6.48417 33.8671 2.90917 41.6965 2.90917C53.1011 2.90917 62.3783 10.5319 62.3783 19.8978C62.2768 24.6617 59.9953 29.1157 56.1886 31.9818C55.2725 32.7279 54.8891 33.9481 55.2136 35.084L56.4693 39.3829L50.3239 37.034C50.1975 38.0329 49.9951 39.0206 49.7182 39.9886L60.9011 44.2727L58.05 34.2715C62.5417 30.8409 65.2232 25.5487 65.3329 19.8978Z",
    fill: "#4D2481"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2057_1753"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 66,
    fill: "white",
    transform: "translate(0.333008)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscuss);
export default __webpack_public_path__ + "static/media/discuss.51d787e32980d021a2b1451668dabed3.svg";
export { ForwardRef as ReactComponent };